export default __webpack_public_path__ + "static/media/kubernetes.ce1f338c.png";